import {
  CENTER_GETALL_SUCCESS,
  CENTER_GETALL_FAIL,
  CENTER_UPSERT_SUCCESS,
  CENTER_UPSERT_FAIL,
  CENTER_DELETE_SUCCESS,
  CENTER_DELETE_FAIL,
  SET_MESSAGE
} from "./types";

import CenterService from "../services/center.service";

export const getCenters = () => (dispatch) => {
  return CenterService.getCenters().then(
    (data) => {
      dispatch({
        type: CENTER_GETALL_SUCCESS,
        payload: { centers: data },
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: CENTER_GETALL_FAIL });
      dispatch({
        type: SET_MESSAGE,
        payload: `Centers retrieval failed : ${error}`,
      });
      return Promise.reject();
    }
  );
};

export const upsertCenter = (center) => (dispatch) => {
  return CenterService.upsertCenter(center).then(
    (data) => {
      dispatch({ type: CENTER_UPSERT_SUCCESS, payload: data });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: CENTER_UPSERT_FAIL });
      dispatch({
        type: SET_MESSAGE,
        payload: `Center upsert failed - ${error}`,
      });
      return Promise.reject();
    }
  );
};

export const deleteCenter = (center_id) => (dispatch) => {
  return CenterService.deleteCenter(center_id).then(
    () => {
      dispatch({ type: CENTER_DELETE_SUCCESS, payload: center_id });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: CENTER_DELETE_FAIL });
      dispatch({ type: SET_MESSAGE, payload: `Center delete failed - ${error}` });
      return Promise.reject();
    }
  );
};